import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { InboxOutlined } from '@ant-design/icons';
import Dragger from 'antd/lib/upload/Dragger';
import { Form, Modal } from 'antd';

import { addSoluterResume } from '~/store/fetchActions/fetchPeople';

export default function AddResume({ isVisible, setVisible, employeeNumber }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [resumes, setResumes] = useState([]);

  const handleSubmit = useCallback(() => {
    const resume = resumes[0];
    if (resumes.length > 0 && resume) {
      dispatch(
        addSoluterResume({
          employeeNumber,
          resume: resume.originFileObj,
        }),
      );

      setResumes([]);
    }
  }, [employeeNumber, resumes, dispatch]);

  const handleCancel = () => {
    setVisible(false);
    setResumes([]);
  };

  const handleClickUpload = useCallback(({ fileList }) => {
    setResumes(fileList);
  }, []);

  return (
    <Modal
      visible={isVisible}
      title="Adicionar Currículo"
      okText="Salvar"
      cancelText="Cancelar"
      onCancel={handleCancel}
      onOk={() => {
        form.validateFields().then(values => {
          setVisible(false);
          handleSubmit(values);
          form.resetFields();
        });
      }}
      okButtonProps={{
        disabled: resumes.length < 1,
      }}
    >
      <Dragger
        fileList={resumes}
        onChange={handleClickUpload}
        beforeUpload={() => false}
        isImageUrl={() => false}
        listType="picture"
        maxCount={1}
        style={{ marginTop: 20 }}
        locale={{
          removeFile: 'Remover arquivo',
        }}
        accept="application/pdf"
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Selecione um arquivo para o currículo</p>
        <p className="ant-upload-hint">
          Arraste para cá ou clique para adicionar um arquivo
        </p>
        <p className="ant-upload-hint">Apenas arquivos PDF são suportados.</p>
      </Dragger>
    </Modal>
  );
}

AddResume.propTypes = {
  employeeNumber: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};

AddResume.defaultProps = {};
